module.exports = __webpack_public_path__ + "3d58d2e9b6df7c42123a136ee43fd107.png";